import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 10l5 5 5-5H7z"
}), 'ArrowDropDownOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowDropDownOutlined.js
// module id = 2089
// module chunks = 2